function Create_slider() {
    // console.log("executed slider");

    setTimeout(() => {
        var $dynamicGallery = $('.cloned-gallery');
        var $dynamicCarousel = $('.cloned-carousel');
        var clonedGalleryVideo =document.querySelector(".cloned-gallery-video-wrapper");

        // Destroy existing Slick instances if present
        if ($dynamicGallery.hasClass('slick-initialized')) {
            console.log("Destroying slick on cloned-gallery");
            $dynamicGallery.slick('unslick');
            var product_active_alt = document.getElementById('product_active_img_alt')?.innerText;
            const parentElement = document.querySelector('.cloned-gallery');
            if (parentElement) {
                const childElements = parentElement.querySelectorAll('.PDP-media-gallery-wrapper');             
                childElements.forEach(child => {
                    if (child.getAttribute('variant-carousel') === product_active_alt) {
                        // console.log("Keeping", child);
                    } else {
                        // console.log("Removing", child);
                        child.remove();
                    }
                });   


                // Remove previously cloned video
                clonedGalleryVideo
                    .querySelectorAll('.cloned-gallery-video')
                    .forEach(el => el.remove());

                // Clone and append video popup
                const originalVideo =
                    document.querySelector('.productView-videoPopup');

                if (originalVideo) {
                    const clonedVideo = originalVideo.cloneNode(true);
                    clonedVideo.classList.add('cloned-gallery-video');
                    parentElement.style.position = 'relative';
                    clonedGalleryVideo.appendChild(clonedVideo);
                    console.log('Video popup added to cloned gallery');
                }
                
                

                const clonedCarousel = document.querySelector('.cloned-carousel');
                const dynamicCarousels = clonedCarousel?.querySelectorAll('.dynamic-carousel') || [];                
                dynamicCarousels.forEach((carousel) => {
                    if (carousel.classList.contains('carousel-hidden')) {
                        // console.log("Removing hidden carousel", carousel);
                        carousel.remove();
                    } else {
                        // console.log("Keeping visible carousel", carousel);
                    }
                });
            }
        }

        if ($dynamicCarousel.hasClass('slick-initialized')) {
            // console.log("Destroying slick on cloned-carousel");
            $dynamicCarousel.slick('unslick');
            var product_active_alt = document.getElementById('product_active_img_alt')?.innerText;
            const parentElement = document.querySelector('.cloned-gallery');
            if (parentElement) {               
                const childElements = parentElement.querySelectorAll('.PDP-media-gallery-wrapper');                
                childElements.forEach(child => {
                    if (child.getAttribute('variant-carousel') === product_active_alt) {
                        // console.log("Keeping", child);
                    } else {
                        // console.log("Removing", child);
                        child.remove();
                    }
                });
                
                const clonedCarousel = document.querySelector('.cloned-carousel');
                const dynamicCarousels = clonedCarousel?.querySelectorAll('.dynamic-carousel') || [];                
                dynamicCarousels.forEach((carousel) => {
                    if (carousel.classList.contains('carousel-hidden')) {
                        // console.log("Removing hidden carousel", carousel);
                        carousel.remove();
                    } else {
                        // console.log("Keeping visible carousel", carousel);
                    }
                });
            }
        }

        // console.log("Initializing slick on cloned-gallery");
        $dynamicGallery.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
               nextArrow: '<button type="button" class="slick-next custom-pdp-gallery-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
            prevArrow: '<button type="button" class="slick-prev custom-pdp-gallery-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
            fade: true,
            asNavFor: '.cloned-carousel'
        });

        // console.log("Initializing slick on cloned-carousel");
        $dynamicCarousel.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.cloned-gallery',
            centerMode: true,
            focusOnSelect: true,
            arrows: true,
            nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
            prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>'
        });

        // console.log("Slider created");

   function logInlineWidths() {
  const galleryElements = document.querySelectorAll('.PDP-media-gallery-wrapper');

  if (galleryElements.length === 0) {
    // console.log('No elements with class "PDP-media-gallery-wrapper" found.');
  } else {

galleryElements.forEach((element, index) => {
    const inlineWidth = element.style.width;
    const img_element = element.querySelector('.img-container img');

    if (inlineWidth && inlineWidth !== '0px') {
        // Ensure the image is fully loaded before getting naturalWidth and naturalHeight
        img_element.onload = () => {
            const naturalWidth = img_element.naturalWidth;
            const naturalHeight = img_element.naturalHeight;

            // Check the condition for naturalWidth and naturalHeight
            if (naturalWidth !== 1080 || naturalHeight !== 1350) {
                img_element.style.width = inlineWidth;
                img_element.style.height = inlineWidth;
                img_element.classList.add('custom-pdp-gallery-width');
            }
        };

        // If the image is already loaded (cached), get naturalWidth and naturalHeight directly
        if (img_element.complete) {
            const naturalWidth = img_element.naturalWidth;
            const naturalHeight = img_element.naturalHeight;

            if (naturalWidth !== 1080 || naturalHeight !== 1350) {
                img_element.style.width = inlineWidth;
                img_element.style.height = inlineWidth;
                img_element.classList.add('custom-pdp-gallery-width');
            }
        }
    }
});

  }
}
setTimeout(logInlineWidths, 2500);
      
    }, 500); 
}
